var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanqueSaudiFransiFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74537 0.000244141L0.0957031 3.24913V9.74689L5.73884 12.9958L11.382 9.74689V3.24913L5.73884 0.000244141H5.74537ZM1.34176 9.03579V4.64523C2.05286 5.1019 2.67263 5.68905 3.17496 6.36753C3.72297 7.11778 4.16007 7.94631 4.46669 8.82703C4.74069 9.59032 4.93641 10.3732 5.05384 11.1756L1.34176 9.03579ZM5.1256 7.54183C4.91031 6.86987 4.59717 6.23053 4.18616 5.64991C3.58597 4.83442 2.84225 4.13637 1.99415 3.59489L5.1256 1.78778V7.54183ZM6.36513 1.78778L9.49658 3.59489C8.64196 4.13637 7.89824 4.83442 7.30457 5.64991C6.89356 6.23053 6.58042 6.86334 6.36513 7.54183V1.78778ZM10.149 9.03579L6.43689 11.1756C6.55432 10.3732 6.75004 9.59032 7.02404 8.82703C7.33066 7.94631 7.76776 7.1243 8.31577 6.36753C8.8181 5.68905 9.43787 5.1019 10.149 4.64523V9.03579Z",
    fill: "#002A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanqueSaudiFransiFavicon);
export default __webpack_public_path__ + "static/media/banque_saudi_fransi_favicon.ff503365e432b6d3b6c5396c69e754b3.svg";
export { ForwardRef as ReactComponent };